"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hasValue_1 = require("./hasValue");

exports.withDefault = function (value, defaultIfNull) {
  if (hasValue_1.hasValue(value)) {
    return value;
  } else {
    return defaultIfNull;
  }
};